export class ChainInvoice {
  chain: string;
  invDate: string;
  invNum: string;
}
